import LisioPopinNames from "./enums/lisio-popin-names";

export class GlobalContext {
  private static _current: GlobalContext;

  private _popinName: LisioPopinNames = LisioPopinNames.POPIN2025;
  private _isMobile: boolean = false;

  private constructor() {}

  public static get current(): GlobalContext {
    if (!this._current) {
      this._current = new GlobalContext();
    }
    return this._current;
  }

  public get popinName(): LisioPopinNames {
    return this._popinName;
  }

  public set popinName(name: LisioPopinNames) {
    this._popinName = name;
  }
  public get isMobile(): boolean {
    return this._isMobile;
  }

  public set isMobile(isMobile: boolean) {
    this._isMobile = isMobile;
  }
}
